import * as Yup from 'yup';

// Definindo o esquema de validação com Yup
export const validationSchema = Yup.object().shape({
    subject: Yup.string().required('Assunto é obrigatória'),
});